// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = $(window).width() / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = $(window).width() / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    new Swiper(".sp-swiper1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });

    new Swiper(".sp-swiper2", {
      speed: 9000,
      autoplay: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: true,
    });

    new Swiper(".sp-swiper3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
    });

    $(".reduce").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) - 1;
      if (num > 0) {
        input.value = num;
        $(this).parent().siblings(".price-group").find(".price1 span").html(((12.99 * num).toFixed(2) + ''))
        $(this).parent().siblings(".price-group").find(".price2 span").html(((29.99 * num).toFixed(2) + ''))
      }
    });
    $(".add").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) + 1;
      input.value = num;
      $(this).parent().siblings(".price-group").find(".price1 span").html(((12.99 * num).toFixed(2) + ''))
      $(this).parent().siblings(".price-group").find(".price2 span").html(((29.99 * num).toFixed(2) + ''))
    });

    $('.sp-btn-style').click(function () {
      const id = $(this).attr('data-id')
      let num = $(this).siblings('.addGroup').find('input').val() ?? 1
      window.location.href = '/cart/' + id + ':' + num
    })


    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        var targetElement = document.getElementById('custom-shopify-app-block');
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        } // 方式一
        // const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        // const offsetTop = targetElement.offsetTop;
        // window.scroll({
        //   top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
        //   behavior: "smooth", // 使用 smooth 实现平滑滚动
        // }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-detail");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 检查是否在sp-part1下
            const isInPart1 = gradually.closest('.sp-part1') !== null;
            const animationDuration = isInPart1 ? '1.5s' : '0.5s';
            
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade ${animationDuration} ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade ${animationDuration} ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 ${animationDuration} ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }



  const textBox = document.querySelector('.animation-text');
  textBox.innerHTML = textBox.textContent.replace(/\S/g, '<span>$&</span>');
  
  document.querySelectorAll('.animation-text span').forEach((span, index) => {
    span.style.setProperty('--delay', `${index * 0.1}s`);
  });
  
  function play(animation = 'blink') {
    textBox.style.setProperty('--animation', animation);
    textBox.classList.remove('animate');
    void textBox.offsetWidth; // 强制回流，重启动画
    textBox.classList.add('animate');
  }
  
  // 先播一次，然后每 3 秒播一次
  play('blink');
  setInterval(() => play('blink'), 5000);




}

mainRender();